var exports = {
  "k": "xdde3148b--bd039b--container",
};

module.exports = exports;
